const resources_data = [
  // {
  //   id: 'books-interview-preparation',
  //   type: 'post',
  //   text: 'We are all guilty of buying more books than the ones we can or have the strength to read. That pile kept growing, and, to me, the...',
  //   title: 'Must-Read Books for Engineers Preparing for Interviews',
  //   image: '/images/blog/put-a-limit-to-your-stack.png',
  //   date: 'May 5th, 2023',
  //   time: '12 min read',
  //   authorImage: '/images/users/miguelbemartin.jpg',
  //   authorName: 'Miguel Ángel Martín',
  //   authorDescription: 'Engineering Book Club Co-founder. Software Developer, musician and runner.',
  //   authorWebsite: 'https://josealobato.com/',
  //   authorTwitter: 'https://twitter.com/JoseALobato',
  // },
  // {
  //   id: 'book-challenge-2025',
  //   type: 'post',
  //   text: 'I love books. Going to the bookstore or the library and searching for the next thing to read is mágical. It reminds me of the days when we bought music records...',
  //   title: 'The challenge of reading 12 books in 2025',
  //   image: '/images/blog/audiobooks.jpg',
  //   date: 'Nov 19th, 2023',
  //   time: '9 min read',
  //   authorImage: '/images/users/miguelbemartin.jpg',
  //   authorName: 'Miguel Martin',
  //   authorDescription: 'Engineering Book Club Co-founder. Software Developer, musician and runner.',
  //   authorWebsite: 'https://miguelangelmartin.me/',
  //   authorTwitter: 'https://twitter.com/JoseALobato',
  // },
  {
    id: 'about-audiobooks',
    type: 'post',
    text: 'I love books. Going to the bookstore or the library and searching for the next thing to read is mágical. It reminds me of the days when we bought music records...',
    title: 'Listening to Audiobooks vs Reading Books',
    image: '/images/blog/audiobooks.jpg',
    date: 'Nov 19th, 2023',
    time: '9 min read',
    authorImage: '/images/users/josealobato.jpg',
    authorName: 'Jose Lobato',
    authorDescription: 'Engineering Book Club Co-founder. Software Developer, musician and runner.',
    authorWebsite: 'https://josealobato.com/',
    authorTwitter: 'https://twitter.com/JoseALobato',
  },
  {
    id: 'put-a-limit-to-your-read-stack',
    type: 'post',
    text: 'We are all guilty of buying more books than the ones we can or have the strength to read. That pile kept growing, and, to me, the...',
    title: 'How to decide what to read next',
    image: '/images/blog/put-a-limit-to-your-stack.png',
    date: 'May 5th, 2023',
    time: '12 min read',
    authorImage: '/images/users/josealobato.jpg',
    authorName: 'Jose Lobato',
    authorDescription: 'Engineering Book Club Co-founder. Software Developer, musician and runner.',
    authorWebsite: 'https://josealobato.com/',
    authorTwitter: 'https://twitter.com/JoseALobato',
  },
  {
    id: 'about-read-routine',
    type: 'post',
    text: 'It seems obvious, but having a routine is the best way to read and make the most of your time reading. In the same way that a writer sits down every day to write like any...',
    title: 'How to build a reading routine',
    image: '/images/blog/about-read-routine.png',
    date: 'May 2th, 2023',
    time: '6 min read',
    authorImage: '/images/users/josealobato.jpg',
    authorName: 'Jose Lobato',
    authorDescription: 'Engineering Book Club Co-founder. Software Developer, musician and runner.',
    authorWebsite: 'https://josealobato.com/',
    authorTwitter: 'https://twitter.com/JoseALobato',
  },
  {
    id: 'take-notes-in-your-books',
    type: 'post',
    text: 'When I was a kid, writing in your books was unacceptable. I remember teachers making me feel like I was destroying my books. Not anymore! I love commenting on my books,...',
    title: 'How to take notes while reading a book',
    image: '/images/blog/taking-notes-in-your-books.jpg',
    date: 'April 12th, 2023',
    time: '8 min read',
    authorImage: '/images/users/josealobato.jpg',
    authorName: 'Jose Lobato',
    authorDescription: 'Engineering Book Club Co-founder. Software Developer, musician and runner.',
    authorWebsite: 'https://josealobato.com/',
    authorTwitter: 'https://twitter.com/JoseALobato',
  },
];

export {resources_data};
